/**
 * Which page opens a show, by stage — the one rule used by the dashboard (table,
 * overview) and the email link landing (`/show?eventId=…`):
 *  - draft: Saved Drafts (a draft has no page of its own);
 *  - new request (not approved, no estimate): request details;
 *  - estimate sent (not approved, estimate generated): estimate view;
 *  - approved: show details, even without an estimate. A show can be approved
 *    straight from the estimate configuration without the estimate ever being
 *    sent (isEstimateGenerated:false); before 2026-10-13 that pair fell through
 *    to "/dashboard" and the eye icon did nothing.
 * A client whose account is not approved yet always lands on the request details.
 */
export type ShowPageRow = {
  _id?: string;
  lifecycle?: string;
  approved?: boolean;
  isEstimateGenerated?: boolean;
  contactInformationId?: unknown;
  assignedCoordinatorId?: unknown[];
};

export type ShowPage = { path: string; state?: Record<string, unknown> };

export function showPageFor(row: ShowPageRow | null | undefined, opts: { clientNotApproved?: boolean } = {}): ShowPage {
  if (row?.lifecycle === "draft") return { path: "/event/partials" };

  const approved = !!row?.approved;
  const estimate = !!row?.isEstimateGenerated;
  const coordinatorId = row?.assignedCoordinatorId?.[0] ? row.assignedCoordinatorId[0] : null;
  const detailsState = { id: row?._id, contactId: row?.contactInformationId, coordinatorId };

  if (opts.clientNotApproved) return { path: "/dashboard/new-request/details", state: detailsState };
  if (approved) return { path: "/dashboard/details", state: detailsState };
  if (estimate) return { path: "/dashboard/estimates/view", state: { id: row?._id, redirect: false } };
  return { path: "/dashboard/new-request/details", state: detailsState };
}
